import { defineMessages } from 'react-intl';

export default defineMessages({
  rewards: {
    id: 'containers.header.rewards',
    defaultMessage: 'Rewards',
  },
  dashboard: {
    id: 'containers.header.dashboard',
    defaultMessage: 'Dashboard',
  },
  register: {
    id: 'containers.header.register',
    defaultMessage: 'Register',
  },
  login: {
    id: 'containers.header.login',
    defaultMessage: 'Login',
  },
  logout: {
    id: 'containers.header.logout',
    defaultMessage: 'Logout',
  },
  logoAlt: {
    id: 'containers.header.logoAlt',
    defaultMessage: "The Art World's Exclusive Domain",
  },
  membership: {
    id: 'containers.header.membership',
    defaultMessage: 'Membership',
  },
  profile: {
    id: 'containers.header.profile',
    defaultMessage: 'Profile',
  },
});



// WEBPACK FOOTER //
// ./src/containers/Header/messages.js